<svg xmlns="http://www.w3.org/2000/svg" width="25" height="15" viewBox="0 0 25 15" fill="none">
  <mask
    id="mask0_8116_20902"
    style="mask-type: luminance"
    maskUnits="userSpaceOnUse"
    x="13"
    y="0"
    width="12"
    height="15">
    <path d="M24.2345 7.49996V0.5H13.3258V14.4999H24.2345V7.49996Z" fill="white" />
  </mask>
  <g mask="url(#mask0_8116_20902)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24.2167 10.4899C24.0357 12.4784 22.4275 13.8323 20.4244 13.9622L18.8475 13.975H17.2711V5.47944V3.11264H17.2771C17.2926 1.9365 18.0136 0.931601 19.0363 0.5H13.3258V14.5H24.2345V10.4899H24.2167Z"
      fill="#FEDB00" />
  </g>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M8.82629 0.5L0 14.5H4.18157C3.21948 14.0344 2.55356 13.1864 2.55356 12.0458C2.55356 11.4873 2.77537 11.1205 3.08505 10.5956L8.31033 2.29976V11.9815L8.30857 11.982C8.28053 13.091 7.62587 14.0444 6.68456 14.5H12.3687V0.5H8.82629Z"
    fill="#FEDB00" />
</svg>
<span> <b>Premium Delivery</b> by Addison Lee </span>
